import { UiLanguages } from '@selfai-platform/shell';

import { AG_GRID_LOCALE_EN } from './ag-grid-locale-en';
import { AG_GRID_LOCALE_RU } from './ag-grid-locale-ru';

export const AG_GRID_TRANSLATION_DICTIONARY: Record<UiLanguages, Record<string, string>> = {
  [UiLanguages.EN]: AG_GRID_LOCALE_EN,
  [UiLanguages.RU]: AG_GRID_LOCALE_RU,
};
